import { ColoursObj, Gutters, Typography } from '@eventr/common-storybook'
import { Stack } from '@mui/material'
import i18n from '../../../i18n/i18next'
import { openBrowser } from '../../../utils'
import { NavigationView } from '../../layout/NavigationView'
import jsonData from './licenses.json'

export const LicensesPage = () => {
    const jsonDataRaw: Record<string, { licenses: string; repository?: string; publisher?: string; email?: string; name: string }> = jsonData
    const keys: string[] = Object.keys(jsonDataRaw)

    return (
        <NavigationView
            navigationBarTitle={i18n.t('account.licences')}
            backButtonAction={() => {
                window.pushPath('/account/about')
            }}
            usePageTransition
        >
            <Gutters style={{ height: '100%' }} topPadding="0px">
                <Stack
                    direction="column"
                    alignItems="flex-start"
                    gap="8px"
                    paddingTop="16px"
                    maxWidth="90vw"
                    sx={{ overflowX: 'hidden', overflowY: 'auto' }}
                >
                    {keys.map((item, index) => {
                        return (
                            <>
                                <Typography
                                    key={index}
                                    width="100%"
                                    variant="bodyBold"
                                    color={ColoursObj.core.primary}
                                >
                                    {jsonDataRaw[item]['name']}
                                </Typography>
                                <div
                                    onClick={() => {
                                        openBrowser(
                                            jsonDataRaw[item]['repository'] ?? ''
                                        )
                                    }}
                                >
                                    <Typography
                                        key={index}
                                        width="100%"
                                        color={ColoursObj.core.primary}
                                    >
                                        {jsonDataRaw[item]['licenses']}
                                        <br />
                                        {jsonDataRaw[item]['repository']}
                                    </Typography>
                                </div>
                            </>
                        )
                    })}
                </Stack>
            </Gutters>
        </NavigationView>
    )
}
